import React from 'react';
import { DateRow, PriceRow, TextRow, VoidButton, VoidedButton } from 'components';
import { Images, PermissionsList, RolePermission, userType } from 'utils';
import { TransactionMoreAction } from './transactionMoreAction';


const blueColor = 'positive-type';
const redColor = 'negative-type';

const sortByNameWithAllFirst = (transactions) => {
  return transactions.sort((a, b) => {
    if (a.name.trim() === 'All') return -1; // "All" comes first
    if (b.name.trim() === 'All') return 1;  // "All" comes first
    return a.name.trim().localeCompare(b.name.trim());
  });
};

const sortByNameWithAlphabetical = (transactions) => {
  return transactions.sort((a, b) => {
    if (a.name.trim() === 'All') return -1; // "All" comes first
    if (b.name.trim() === 'All') return 1;  // "All" comes first

    // Sort transactions where warn is true to the end
    if (a.warn && !b.warn) return 1; // Move warn items to the end
    if (!a.warn && b.warn) return -1; // Move warn items to the end

    return a.name.trim().localeCompare(b.name.trim());
  });
};

export const TxnType = {
  //users can use these
  EXAM_FEE: 'EXAM_FEE',
  RATEADJUSTMENT: 'RATEADJUSTMENT',
  DWELL_FEE: 'DWELL_FEE',
  WAREHOUSING: 'WAREHOUSING',
  DRIVERASSIST: 'DRIVERASSIST',
  LATEFEE: 'LATEFEE',
  LUMPER: 'LUMPER',
  PICK_UP_FEE: 'PICK_UP_FEE',
  DELIVER_FEE: 'DELIVER_FEE',
  DETENTION: 'DETENTION',
  LAYOVER: 'LAYOVER',
  QUICKPAY_REVERSAL: 'QUICKPAY_REVERSAL',

  //system also can use these
  INITIALRATE: 'INITIALRATE',
  SHORTPAY: 'SHORTPAY',
  CLAIM: 'CLAIM',
  EFS: 'EFS',
  FUEL: 'FUEL',
  CUSTOMERPAYMENT: 'CUSTOMERPAYMENT',
  CARRIERPAYMENT: 'CARRIERPAYMENT',
  COLLECTIONAPPLIED: 'COLLECTIONAPPLIED',
  QUICKPAY: 'QUICKPAY',
  FUEL_FEE: 'FUEL_FEE',

  PALLETIZING: 'PALLETIZING',
  DRAYAGE: 'DRAYAGE',
  CHASSIS_FEE: 'CHASSIS_FEE',
  DROP_FEE: 'DROP_FEE',
  ATTEMPT: 'ATTEMPT',
  FSC: 'FSC',
  PRE_PULL: 'PRE_PULL',
  PRE_DIEM: 'PRE_DIEM',
  PIER_PASS: 'PIER_PASS',
  CONTAINER_STORAGE: 'CONTAINER_STORAGE',
  CHASSIS_SPLIT: 'CHASSIS_SPLIT',
  DEMURRAGE: 'DEMURRAGE',
  CORPORATE: 'CORPORATE',
  OFFICE_CHARGE: 'OFFICE_CHARGE',
  LPF_CARRIER_CHARGE: 'LPF_CARRIER_CHARGE',
  LPF_CARRIER_CREDIT: 'LPF_CARRIER_CREDIT',
  LPF_AGENT_CHARGE: 'LPF_AGENT_CHARGE',
  LPF_AGENT_CREDIT: 'LPF_AGENT_CREDIT',
  FINANCE_FEE: 'FINANCE_FEE',
  CUSTOMER_PREPAY: 'CUSTOMER_PREPAY',
  FLIP_FEE: 'FLIP_FEE',
  ISC_FEE: 'ISC_FEE',
  PMC_FEE: 'PMC_FEE',
  AIR_WAREHOUSING: 'AIR_WAREHOUSING',
  STOP_OFF: 'STOP_OFF',
  DRY_RUN: 'DRY_RUN',
  BOBTAIL: 'BOBTAIL',
  PREPAY_FEE: 'PREPAY_FEE',
  PREPAID_EXPENSE: 'PREPAID_EXPENSE',
  VENDOR_EXPENSE: 'VENDOR_EXPENSE',
  DISPOSAL: 'DISPOSAL',
  TRIPPER: 'TRIPPER',
  TRANSPORTATION: 'TRANSPORTATION',
  VENDOR_CHARGE: 'VENDOR_CHARGE',
  RESERVE: 'RESERVE',
  RESERVE_RELEASE: 'RESERVE_RELEASE',
  RESERVE_CHARGE: 'RESERVE_CHARGE',
  COLLECTION_TRANSFERRED: 'COLLECTION_TRANSFERRED',
  SCALE_TICKET: 'SCALE_TICKET',
  CUSTOMS_FEE: 'CUSTOMS_FEE',
  OVERWEIGHT_FEE: 'OVERWEIGHT_FEE',
  PORT_CONGESTION_FEE: 'PORT_CONGESTION_FEE',
  PORT_FEE: 'PORT_FEE',
  DUTY_OF_ENTRY_FEE: 'DUTY_OF_ENTRY_FEE',
  MERCHANDISE_PROCESSING_FEE: 'MERCHANDISE_PROCESSING_FEE',
  HARBOR_MAINTENANCE_FEE: 'HARBOR_MAINTENANCE_FEE',
  CARRIER_RELEASE_VERIFICATION: 'CARRIER_RELEASE_VERIFICATION',
  COMMUNICATIONS: 'COMMUNICATIONS',
  CUSTOMS_CLEARANCE_FEE: 'CUSTOMS_CLEARANCE_FEE',
  FDA_FILING_FEE: 'FDA_FILING_FEE',
  INTERNATIONAL_FREIGHT: 'INTERNATIONAL_FREIGHT',
  ORIGIN_EX_WORKS: 'ORIGIN_EX_WORKS',
  AMS_FILING: 'AMS_FILING',
  DESTINATION_DOC_TRANSFER_FEE: 'DESTINATION_DOC_TRANSFER_FEE',
  CFS_WHSE_FEE: 'CFS_WHSE_FEE',
  DESTINATION_CARTAGE: 'DESTINATION_CARTAGE',
  IMPORTER_SECURITY_FILING_FEE: 'IMPORTER_SECURITY_FILING_FEE',
  INTERNATIONAL_FREIGHT_RAIL: 'INTERNATIONAL_FREIGHT_RAIL',
  INTERNATIONAL_FREIGHT_AIR: 'INTERNATIONAL_FREIGHT_AIR',
  EU_FEE: 'EU_FEE',
  TRANSLOADING_SERVICES: 'TRANSLOADING_SERVICES',
  FINAL_MILE_DELIVERY: 'FINAL_MILE_DELIVERY',
  OUT_OF_GAUGE: 'OUT_OF_GAUGE',
  DTHC: 'DTHC',
  ORIGIN_HANDLING: 'ORIGIN_HANDLING',
  DESTINATION_TRANSMISSION: 'DESTINATION_TRANSMISSION',
  AIRPORT_TRANSFER: 'AIRPORT_TRANSFER',
  FUEL_SURCHARGE_AIRLINE: 'FUEL_SURCHARGE_AIRLINE',
  AIRLINE_SCREENING_FEE: 'AIRLINE_SCREENING_FEE',
  CUSTOMER_EXPENSE: 'CUSTOMER_EXPENSE',
  ANNUAL_BOND_FEE: 'ANNUAL_BOND_FEE',
  HAZMAT_FEE: 'HAZMAT_FEE',
  BONDED_FEE:'BONDED_FEE',
  FILING_7512: 'FILING_7512',
  ARRIVAL_NOTICE_FEE:'ARRIVAL_NOTICE_FEE',
  DOT_HANDLING_FEE:'DOT_HANDLING_FEE',
  CUSTOMER_OVERPAY_VENDOR: 'CUSTOMER_OVERPAY_VENDOR',
  CUSTOMER_SHORTPAY_VENDOR: 'CUSTOMER_SHORTPAY_VENDOR',
  CUSTOMER_OVERPAY_AGENT: 'CUSTOMER_OVERPAY_AGENT',
  CUSTOMER_SHORTPAY_AGENT: 'CUSTOMER_SHORTPAY_AGENT',
  AIR_FREIGHT_CHARGE: 'AIR_FREIGHT_CHARGE',
  OCEAN_FREIGHT_CHARGE: 'OCEAN_FREIGHT_CHARGE',
  VENDOR_PREPAID: 'VENDOR_PREPAID',





  LIBERATION_TARIFF_FEE: 'LIBERATION_TARIFF_FEE',
  LIFTGATE_SERVICE_FEE: 'LIFTGATE_SERVICE_FEE',
  GROUND_TRANSPORTATION: 'GROUND_TRANSPORTATION',
  LCL_OCEAN_FREIGHT: 'LCL_OCEAN_FREIGHT',
  FCL_OCEAN_FREIGHT: 'FCL_OCEAN_FREIGHT',
  DUTY_AND_VAT: 'DUTY_AND_VAT',
  DAILY_STORAGE: 'DAILY_STORAGE',
  WEEKLY_STORAGE: 'WEEKLY_STORAGE',
  MONTHLY_STORAGE: 'MONTHLY_STORAGE',
  ANNUAL_STORAGE: 'ANNUAL_STORAGE',
  PROJECT_REWORK: 'PROJECT_REWORK',
  ASSEMBLY: 'ASSEMBLY',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  CTF_TMF: 'CTF_TMF',

};


const sameTransactions = [
  { name: 'Bobtail', id: TxnType.BOBTAIL },
  { name: 'Dry Run', id: TxnType.DRY_RUN },
  { name: 'Duties and fees', id: 'DUTIES_AND_FEES' },
  { name: 'Entry service fee', id: 'ENTRY_SERVICE_FEE' },
  { name: 'FDA fee', id: 'FDA_FEE' },
  { name: 'Finance fee', id: TxnType.FINANCE_FEE },
  { name: 'Flip fee', id: TxnType.FLIP_FEE },
  { name: 'ISF fee', id: 'ISF_FEE' },
  { name: 'PMC Fee', id: TxnType.PMC_FEE },
  { name: 'Rate Adjustment ', id: TxnType.RATEADJUSTMENT },
  { name: 'Single bond fee', id: 'SINGLE_BOND_FEE' },
  { name: 'Stop Off', id: TxnType.STOP_OFF },
  { name: 'Base Rate', id: TxnType.INITIALRATE },
  { name: 'Disposal', id: TxnType.DISPOSAL },
  { name: 'Tipper Fee', id: TxnType.TRIPPER },
  { name: 'Transportation', id: TxnType.TRANSPORTATION },
  { name: 'Scale Ticket', id: TxnType.SCALE_TICKET },
  { name: 'Customs Fee', id: TxnType.CUSTOMS_FEE },
  { name: 'Overweight Fee', id: TxnType.OVERWEIGHT_FEE },
  { name: 'Port Congestion Fee', id: TxnType.PORT_CONGESTION_FEE },
  { name: 'Port Fee', id: TxnType.PORT_FEE },
  { name: 'Duty per Copy of Entry', id: TxnType.DUTY_OF_ENTRY_FEE },
  { name: 'Merchandise Processing Fee', id: TxnType.MERCHANDISE_PROCESSING_FEE },
  { name: 'Harbor Maintenance Fee', id: TxnType.HARBOR_MAINTENANCE_FEE },
  { name: 'Carrier Release Verification', id: TxnType.CARRIER_RELEASE_VERIFICATION },
  { name: 'Communications', id: TxnType.COMMUNICATIONS },
  { name: 'Customs Clearance Fee', id: TxnType.CUSTOMS_CLEARANCE_FEE },
  { name: 'FDA And/or Prior Notice Filing Fee', id: TxnType.FDA_FILING_FEE },
  { name: 'International Freight', id: TxnType.INTERNATIONAL_FREIGHT },
  { name: 'Origin Ex Works', id: TxnType.ORIGIN_EX_WORKS },
  { name: 'AMS Filing', id: TxnType.AMS_FILING },
  { name: 'Destination Document Transfer Fee', id: TxnType.DESTINATION_DOC_TRANSFER_FEE },
  { name: 'CFS WHSE Fee/Devanning', id: TxnType.CFS_WHSE_FEE },
  { name: 'Destination Cartage', id: TxnType.DESTINATION_CARTAGE },
  { name: 'Importer Security Filing Fee', id: TxnType.IMPORTER_SECURITY_FILING_FEE },
  { name: 'International Freight Rail China - EU', id: TxnType.INTERNATIONAL_FREIGHT_RAIL },
  { name: 'International Freight Air China - EU', id: TxnType.INTERNATIONAL_FREIGHT_AIR },
  { name: 'EU Fee', id: TxnType.EU_FEE },
  { name: 'Transloading Services', id: TxnType.TRANSLOADING_SERVICES },
  { name: 'Final Mile Delivery', id: TxnType.FINAL_MILE_DELIVERY },
  { name: 'Out of Gauge Fee', id: TxnType.OUT_OF_GAUGE },
  { name: 'Destination Terminal Handling Charge', id: TxnType.DTHC },
  { name: 'Origin Handling', id: TxnType.ORIGIN_HANDLING },
  { name: 'Destination Document Transmission', id: TxnType.DESTINATION_TRANSMISSION },
  { name: 'Airport Transfer', id: TxnType.AIRPORT_TRANSFER },
  { name: 'Fuel Surcharge Airline', id: TxnType.FUEL_SURCHARGE_AIRLINE },
  { name: 'Airline Screening Fee', id: TxnType.AIRLINE_SCREENING_FEE },
  { name: 'Annual bond fee', id: TxnType.ANNUAL_BOND_FEE },
  { name: 'HazMat Fee', id: TxnType.HAZMAT_FEE },
  { name: 'Bonded Fee', id: TxnType.BONDED_FEE },
  { name: '7512 Filing', id: TxnType.FILING_7512 },
  { name: 'Arrival Notice Fee', id: TxnType.ARRIVAL_NOTICE_FEE },
  { name: 'DOT Handling Fee', id: TxnType.DOT_HANDLING_FEE },
  { name: 'Air Freight Charge', id: TxnType.AIR_FREIGHT_CHARGE },
  { name: 'Ocean Freight Charge', id: TxnType.OCEAN_FREIGHT_CHARGE },


  { name: 'Liberation Tariff Fee', id: TxnType.LIBERATION_TARIFF_FEE },
  { name: 'Liftgate Service Fee', id: TxnType.LIFTGATE_SERVICE_FEE },
  { name: 'Ground Transportation', id: TxnType.GROUND_TRANSPORTATION },
  { name: 'LCL - Ocean Freight', id: TxnType.LCL_OCEAN_FREIGHT },
  { name: 'FCL - Ocean Freight', id: TxnType.FCL_OCEAN_FREIGHT },
  { name: 'Duty & VAT', id: TxnType.DUTY_AND_VAT },
  { name: 'Daily Storage', id: TxnType.DAILY_STORAGE },
  { name: 'Weekly Storage', id: TxnType.WEEKLY_STORAGE },
  { name: 'Monthly Storage', id: TxnType.MONTHLY_STORAGE },
  { name: 'Annual Storage', id: TxnType.ANNUAL_STORAGE },
  { name: 'Project Rework', id: TxnType.PROJECT_REWORK },
  { name: 'Assembly', id: TxnType.ASSEMBLY },
  { name: 'Export', id: TxnType.EXPORT },
  { name: 'Import', id: TxnType.IMPORT },
  { name: 'CTF/TMF', id: TxnType.CTF_TMF },
];
export const transactionStatuses = [
  { name: 'All', id: '' },
  { name: 'Void', id: 'APPLIED' },
  { name: 'Voided', id: 'VOID' },
  { name: 'Pending', id: 'PENDING' },
];
export const transactionHead = [
  { name: '', title: 'Created Date', icon: 'date', custom: false, width: '100px' },
  { name: '', title: 'Creator', custom: false },
  {
    name: 'type', title: 'Type',
    filterList: sortByNameWithAllFirst([
      { name: 'All', id: '' },
      { name: 'Exam fee ', id: TxnType.EXAM_FEE },
      { name: 'Warehousing', id: TxnType.WAREHOUSING },
      { name: 'Lumper', id: 'LUMPER' },
      { name: 'Detention', id: 'DETENTION' },
      { name: 'Layover', id: 'LAYOVER' },
      { name: 'Base Rate', id: 'INITIALRATE' },
      { name: 'Customer Payment', id: 'CUSTOMERPAYMENT' },
      { name: 'Palletizing', id: 'PALLETIZING' },
      { name: 'Drayage', id: 'DRAYAGE' },
      { name: 'Chassis Fee', id: 'CHASSIS_FEE' },
      { name: 'Drop Fee', id: 'DROP_FEE' },
      { name: 'FSC', id: 'FSC' },
      { name: 'Pre-Pull', id: 'PRE_PULL' },
      { name: 'Per Diem', id: 'PRE_DIEM' },
      { name: 'Pier Pass (CTF/TMF) fee', id: 'PIER_PASS' },
      { name: 'Container Storage', id: 'CONTAINER_STORAGE' },
      { name: 'Demurrage', id: 'DEMURRAGE' },
      { name: 'Chassis Split', id: 'CHASSIS_SPLIT' },
      { name: 'Prepaid Expense', id: TxnType.PREPAY_FEE },
      ...sameTransactions,
    ]),
  },
  { name: '', title: 'Rate', custom: false },
  { name: 'qty', title: 'Qty', custom: false, width: '100px' },
  { name: '', title: 'Total', custom: false },
  { name: '', title: 'Description', custom: false },
  {
    name: 'status', title: 'Status', custom: false,
    // filterList: transactionStatuses,
    width: '120px',
  },
  { name: '', title: 'Action', custom: false, width: '50px' },

];

export const CarrierTransactionTypes = [
  { name: 'All', id: '' },
  { name: 'Exam fee', id: TxnType.EXAM_FEE },
  { name: 'Warehousing', id: TxnType.WAREHOUSING },
  { name: 'Lumper', id: 'LUMPER' },
  { name: 'Detention', id: 'DETENTION' },
  { name: 'Layover', id: 'LAYOVER' },
  // { name: 'Base Rate', id: 'INITIALRATE' },
  { name: 'Efs', id: 'EFS' },
  { name: 'Fuel', id: 'FUEL' },
  { name: 'Collection Applied', id: 'COLLECTIONAPPLIED' },
  { name: 'Quick Pay', id: 'QUICKPAY' },
  { name: 'Carrier Payment', id: 'CARRIERPAYMENT' },
  { name: 'Quickpay Reversal', id: 'QUICKPAY_REVERSAL' },
  { name: 'Fuel advance fee', id: 'FUEL_FEE' },
  { name: 'Palletizing', id: 'PALLETIZING' },
  { name: 'Drayage', id: 'DRAYAGE' },
  { name: 'Chassis Fee', id: 'CHASSIS_FEE' },
  { name: 'Drop Fee', id: 'DROP_FEE' },
  { name: 'FSC', id: 'FSC' },
  { name: 'Pre-Pull', id: 'PRE_PULL' },
  { name: 'Per Diem', id: 'PRE_DIEM' },
  { name: 'Pier Pass (CTF/TMF) fee', id: 'PIER_PASS' },
  { name: 'Container Storage', id: 'CONTAINER_STORAGE' },
  { name: 'Demurrage', id: 'DEMURRAGE' },
  { name: 'Chassis Split', id: 'CHASSIS_SPLIT' },
  { name: 'Processing Fee', id: 'PROCESSING_FEE' },
  { name: 'Processing Fee Charge', id: 'LPF_CARRIER_CHARGE' },
  { name: 'Quickpay', id: 'QUICKPAY' },
  { name: 'Customer Expense', id: TxnType.CUSTOMER_EXPENSE },
  { name: 'Vendor Expense', id: TxnType.VENDOR_EXPENSE },
  { name: 'Reserve', id: TxnType.RESERVE },
  { name: 'Reserve Release', id: TxnType.RESERVE_RELEASE },
  { name: 'Reserve Charge', id: TxnType.RESERVE_CHARGE },
  { name: 'Collection Transferred', id: TxnType.COLLECTION_TRANSFERRED },
  ...sameTransactions,
];

export const carrierTransactionHead = [
  { name: '', title: 'Created Date', icon: 'date', custom: false, width: '100px' },
  { name: '', title: 'Creator', custom: false },
  {
    name: 'type', title: 'Type',
    filterList: sortByNameWithAllFirst(CarrierTransactionTypes),
  },
  { name: '', title: 'Rate', custom: false },
  { name: 'qty', title: 'Qty', custom: false, width: '100px' },
  { name: '', title: 'Total', custom: false },
  { name: '', title: 'Description', custom: false },
  {
    name: 'carrierVoid', title: 'Status', custom: false,
    // filterList: transactionStatuses,
    width: '120px',
  },
  { name: '', title: 'Action', custom: false, width: '50px' },
];

export const transactionBody = () => [
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  { rowText: (item) => <TextRow name={item?.username} textWidth={10} /> },
  { rowText: (item) => <div>{handleGetTypes(item)}</div> },
  {
    rowText: (item) => renderPriceRow(item?.amount, item),
    // <p className={item.amount > 0 ? blueColor : redColor}>
    //   <PriceRow info={item?.amount} />
    // </p>,
  },
  { rowText: (item) => <TextRow name={item?.qty ? item?.qty : 1} textWidth={10} /> },
  {
    rowText: (item) => renderPriceRow(item?.totalAmount, item),
    // <p className={item.amount > 0 ? blueColor : redColor}>
    //   <PriceRow info={item?.totalAmount ? item?.totalAmount : 0} />
    // </p>,
  },
  {
    rowText: (item) => <div className="align-center">
      <TextRow name={item?.description} textWidth={13} />
      {/*<button className="reset-btn" onClick={() => editDesc(item)}>*/}
      {/*  <img src={Images.edit} alt="edit" />*/}
      {/*</button>*/}
    </div>,
  },
  { rowText: (item) => renderTxnsStatus(item) },
  { rowText: (item) => <TransactionMoreAction item={item} />, notClickable: true },
];

export const renderColors = (item) => {
  switch (item.type) {
    case TxnType.QUICKPAY:
    case TxnType.CARRIERPAYMENT:
    case TxnType.LPF_CARRIER_CHARGE:
    case TxnType.FUEL:
    case TxnType.FUEL_FEE:
    case TxnType.EFS:
    case TxnType.LPF_AGENT_CHARGE:
    case TxnType.CUSTOMERPAYMENT:
    case TxnType.VENDOR_CHARGE:
    case TxnType.COLLECTIONAPPLIED:
    case TxnType.RESERVE:
    case TxnType.RESERVE_CHARGE:
      if (item.amount > 0) return redColor;
      return blueColor;
    //Everything else is the opposite
    default:
      if (item.amount > 0) return blueColor;
      return redColor;
  }
};

export const renderPriceRow = (amount, item) => {
  if (renderColors(item) === 'negative-type') {
    return <p className={redColor}><PriceRow info={amount} minuse={true} /></p>;
  } else {
    return <p className={blueColor}><PriceRow info={amount} pluse={true} /></p>;
  }
};


export const transactionCarrierBody = (editDesc) => [
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  { rowText: (item) => <TextRow name={item?.username} textWidth={10} /> },
  { rowText: (item) => <div>{handleGetTypes(item)}</div> },
  {
    rowText: (item) => renderPriceRow(item?.amount, item),
    // <p className={renderColors(item)}>
    //   <PriceRow info={item?.amount} />
    // </p>,
  },
  {
    rowText: (item) => <TextRow name={item?.qty ? item?.qty : 1} textWidth={10} />,
  },
  {
    rowText: (item) => renderPriceRow(item?.totalAmount, item),
    // <p className={renderColors(item)}>
    //   <PriceRow info={item?.totalAmount} />
    // </p>,
  },
  {
    rowText: (item) => <div className="align-center">
      <TextRow name={item?.description} textWidth={13} />
      {/*<button className="reset-btn" onClick={() => editDesc(item)}>*/}
      {/*  <img src={Images.edit} alt="edit" />*/}
      {/*</button>*/}
    </div>,
  },
  { rowText: (item) => renderTxnsStatus(item) },
  { rowText: (item) => <TransactionMoreAction item={item} />, notClickable: true },
];


export const ACTION_TYPE = 'GET_LOAD_TRANSACTIONS';
export const CARRIER_TXNS_ACTION_TYPE = 'GET_LOAD_CARRIER_TRANSACTIONS';
export const OTHER_TXNS_ACTION_TYPE = 'GET_LOAD_OTHER_TRANSACTIONS';

const renderButton = (item, info) => {
  if (info?.status === 'VOID') {
    return <VoidedButton />;
  } else if (
    userType === 'ADMIN' && RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.TRANSACTION_VOID_BUTTON?.code]) &&
    info?.type !== TxnType.QUICKPAY_REVERSAL && info?.type !== TxnType.QUICKPAY &&
    info?.type !== TxnType.CUSTOMERPAYMENT && info?.type !== TxnType.CARRIERPAYMENT &&
    info?.type !== TxnType.FUEL_FEE && info?.type !== TxnType.LPF_AGENT_CHARGE &&
    info?.type !== TxnType.LPF_AGENT_CREDIT && info?.type !== TxnType.LPF_CARRIER_CHARGE &&
    info?.type !== TxnType.LPF_CARRIER_CREDIT
    // && info?.type !== TxnType.INITIALRATE
  ) {
    return <VoidButton handleClick={() => item(info)} />;
  } else {
    return '  ';
  }
};

export const transactionStatusEnums = {
  APPLIED: 'APPLIED',
  VOID: 'VOID',
  PENDING: 'PENDING',
};
export const renderTxnsStatus = (info) => {
  if (info?.status === transactionStatusEnums?.APPLIED) {
    return <div style={{ color: '#39AB44' }}>Active</div>;
  }
  if (info?.status === transactionStatusEnums?.VOID) {
    return <div style={{ color: '#62697E' }}>Voided</div>;
  }
  if (info?.status === transactionStatusEnums?.PENDING) {
    return <div style={{ color: '#F79009' }}>Pending</div>;
  }
};

export const handleGetTypes = (data) => {
  return data?.type === 'CUSTOMERPAYMENT' ? 'Customer Payment' :
    data?.type === 'CARRIERPAYMENT' ? 'Carrier Payment' :
      data?.type === TxnType.PREPAY_FEE ? 'Prepaid Expense' :
        data?.type === TxnType.EXAM_FEE ? 'Exam Fee' :
          data?.type === TxnType.RATEADJUSTMENT ? 'Rate Adjustment' :
            data?.type === TxnType.STOP_OFF ? 'Stop Off' :
              data?.type === TxnType.DRY_RUN ? 'Dry Run' :
                data?.type === TxnType.BOBTAIL ? 'Bobtail' :
                  data?.type === TxnType.DWELL_FEE ? 'Dwell Fee' :
                    data?.type === 'DELIVER_FEE' ? 'Deliver Fee' :
                      data?.type === 'PICK_UP_FEE' ? 'Pickup Fee' :
                        data?.type === 'DRIVERASSIST' ? 'Driver Assist' :
                          data?.type === TxnType.WAREHOUSING ? 'Warehousing' :
                            data?.type === 'INITIALRATE' ? 'Base Rate' :
                              data?.type === TxnType.LATEFEE ? 'Late fee' :
                                data?.type === 'SHORTPAY' ? 'Short Pay' :
                                  data?.type === 'COLLECTIONAPPLIED' ? 'Collection Applied' :
                                    data?.type === 'QUICKPAY' ? 'Quick Pay' :
                                      data?.type === 'QUICKPAY_REVERSAL' ? 'Quickpay Reversal' :
                                        data?.type === 'FUEL_FEE' ? 'Fuel advance fee' :
                                          data?.type === 'CHASSIS_FEE' ? 'Chassis Fee' :
                                            data?.type === 'DROP_FEE' ? 'Drop Fee' :
                                              data?.type === 'PRE_PULL' ? 'Pre-Pull' :
                                                data?.type === 'PIER_PASS' ? 'Pier Pass (CTF/TMF) fee' :
                                                  data?.type === 'CONTAINER_STORAGE' ? 'Container Storage' :
                                                    data?.type === 'CHASSIS_SPLIT' ? 'Chassis Split' :
                                                      data?.type === 'OFFICE_CHARGE' ? 'Office Transaction' :
                                                        data?.type === 'CORPORATE' ? 'Corporate Transaction' :
                                                          data?.type === 'LPF_CARRIER_CHARGE' ? 'LPF Charge' :
                                                            data?.type === 'LPF_REVERSAL' ? 'LPF reversal' :
                                                              data?.type === 'LPF_CARRIER_CREDIT' ? 'LPF Credit' :
                                                                data?.type === 'LPF_AGENT_CHARGE' ? 'LPF Agent Charge' :
                                                                  data?.type === 'LPF_AGENT_CREDIT' ? 'LPF Agent Credit' :
                                                                    data?.type === 'QUICKPAY' ? 'Quickpay' :
                                                                      data?.type === 'EXTRA_TO_RATE' ? 'Extra to rate' :
                                                                        data?.type === 'DUTIES_AND_FEES' ? 'Duties and fees' :
                                                                          data?.type === 'ENTRY_SERVICE_FEE' ? 'Entry service fee' :
                                                                            data?.type === 'SINGLE_BOND_FEE' ? 'Single bond fee' :
                                                                              data?.type === 'FDA_FEE' ? 'FDA fee' :
                                                                                data?.type === 'ISF_FEE' ? 'ISF fee' :
                                                                                  data?.type === TxnType.FINANCE_FEE ? 'Finance fee' :
                                                                                    data?.type === TxnType.CUSTOMER_PREPAY ? 'Customer Prepay' :
                                                                                      data?.type === TxnType.FLIP_FEE ? 'Flip fee' :
                                                                                        data?.type === TxnType.ISC_FEE ? 'ISC Import Service Fee' :
                                                                                          data?.type === TxnType.PMC_FEE ? 'PMC Fee' :
                                                                                            data?.type === TxnType.AIR_WAREHOUSING ? 'Air Warehousing' :
                                                                                              data?.type === TxnType.PREPAID_EXPENSE ? 'Prepaid Expense' :
                                                                                                data?.type === TxnType.VENDOR_EXPENSE ? 'Vendor Expense' :
                                                                                                data?.type === TxnType.CUSTOMER_EXPENSE ? 'Customer Expense' :
                                                                                                  data?.type === TxnType.DISPOSAL ? 'Disposal' :
                                                                                                    data?.type === TxnType.TRIPPER ? 'Tipper Fee' :
                                                                                                      data?.type === TxnType.TRANSPORTATION ? 'Transportation' :
                                                                                                        data?.type === TxnType.VENDOR_CHARGE ? 'Vendor Charge' :
                                                                                                          data?.type === TxnType.RESERVE ? 'Reserve' :
                                                                                                            data?.type === TxnType.RESERVE_RELEASE ? 'Reserve Release' :
                                                                                                              data?.type === TxnType.RESERVE_CHARGE ? 'Reserve Charge' :
                                                                                                                data?.type === TxnType.COLLECTION_TRANSFERRED ? 'Collection Transferred' :
                                                                                                                  data?.type === TxnType.SCALE_TICKET ? 'Scale Ticket' :
                                                                                                                    data?.type === TxnType.CUSTOMS_FEE ? 'Customs Fee' :
                                                                                                                      data?.type === TxnType.OVERWEIGHT_FEE ? 'Overweight Fee' :
                                                                                                                        data?.type === TxnType.PORT_CONGESTION_FEE ? 'Port Congestion Fee' :
                                                                                                                          data?.type === TxnType.PORT_FEE ? 'Port Fee' :
                                                                                                                            data?.type === TxnType.DEMURRAGE ? 'Demurrage' :
                                                                                                                              data?.type === TxnType.DUTY_OF_ENTRY_FEE ? 'Duty per Copy of Entry' :
                                                                                                                                data?.type === TxnType.MERCHANDISE_PROCESSING_FEE ? 'Merchandise Processing Fee' :
                                                                                                                                  data?.type === TxnType.HARBOR_MAINTENANCE_FEE ? 'Harbor Maintenance Fee' :
                                                                                                                                    data?.type === TxnType.CARRIER_RELEASE_VERIFICATION ? 'Carrier Release Verification' :
                                                                                                                                      data?.type === TxnType.COMMUNICATIONS ? 'Communications' :
                                                                                                                                        data?.type === TxnType.CUSTOMS_CLEARANCE_FEE ? 'Customs Clearance Fee' :
                                                                                                                                          data?.type === TxnType.FDA_FILING_FEE ? 'FDA And/or Prior Notice Filing Fee' :
                                                                                                                                            data?.type === TxnType.INTERNATIONAL_FREIGHT ? 'International Freight' :
                                                                                                                                              data?.type === TxnType.ORIGIN_EX_WORKS ? 'Origin Ex Works' :
                                                                                                                                                data?.type === TxnType.AMS_FILING ? 'AMS Filing' :
                                                                                                                                                  data?.type === TxnType.DESTINATION_DOC_TRANSFER_FEE ? 'Destination Document Transfer Fee' :
                                                                                                                                                    data?.type === TxnType.CFS_WHSE_FEE ? 'CFS WHSE Fee/Devanning' :
                                                                                                                                                      data?.type === TxnType.DESTINATION_CARTAGE ? 'Destination Cartage' :
                                                                                                                                                        data?.type === TxnType.IMPORTER_SECURITY_FILING_FEE ? 'Importer Security Filing Fee' :
                                                                                                                                                          data?.type === TxnType.INTERNATIONAL_FREIGHT_RAIL ? 'International Freight Rail China - EU' :
                                                                                                                                                            data?.type === TxnType.INTERNATIONAL_FREIGHT_AIR ? 'International Freight Air China - EU' :
                                                                                                                                                              data?.type === TxnType.EU_FEE ? 'EU Fee' :
                                                                                                                                                                data?.type === TxnType.TRANSLOADING_SERVICES ? 'Transloading Services' :
                                                                                                                                                                  data?.type === TxnType.FINAL_MILE_DELIVERY ? 'Final Mile Delivery' :
                                                                                                                                                                    data?.type === TxnType.OUT_OF_GAUGE ? 'Out of Gauge Fee' :
                                                                                                                                                                      data?.type === TxnType.DTHC ? 'Destination Terminal Handling Charge' :
                                                                                                                                                                        data?.type === TxnType.ORIGIN_HANDLING ? 'Origin Handling' :
                                                                                                                                                                          data?.type === TxnType.DESTINATION_TRANSMISSION ? 'Destination Document Transmission' :
                                                                                                                                                                            data?.type === TxnType.AIRPORT_TRANSFER ? 'Airport Transfer' :
                                                                                                                                                                              data?.type === TxnType.FUEL_SURCHARGE_AIRLINE ? 'Fuel Surcharge Airline' :
                                                                                                                                                                                data?.type === TxnType.AIRLINE_SCREENING_FEE ? 'Airline Screening Fee' :
                                                                                                                                                                                data?.type === TxnType.ANNUAL_BOND_FEE ? 'Annual bond fee' :

                                                                                                                  data?.type === TxnType.HAZMAT_FEE ? 'HazMat Fee' :
                                                                                                                    data?.type === TxnType.BONDED_FEE ? 'Bonded Fee' :
                                                                                                                      data?.type === TxnType.FILING_7512 ? '7512 Filing' :
                                                                                                                        data?.type === TxnType.ARRIVAL_NOTICE_FEE ? 'Arrival Notice Fee' :
                                                                                                                          data?.type === TxnType.DOT_HANDLING_FEE ? 'DOT Handling Fee' :



                                                                                                                            data?.type === TxnType.CUSTOMER_OVERPAY_VENDOR ? 'Customer Over Pay to Vendor' :
                                                                                                                              data?.type === TxnType.CUSTOMER_SHORTPAY_VENDOR ? 'Customer Short Pay to Vendor' :
                                                                                                                                data?.type === TxnType.CUSTOMER_OVERPAY_AGENT ? 'Customer Over Pay to Agent' :
                                                                                                                                data?.type === TxnType.CUSTOMER_SHORTPAY_AGENT ? 'Customer Short Pay to Agent' :
                                                                                                                                data?.type === TxnType.AIR_FREIGHT_CHARGE ? 'Air Freight Charge' :
                                                                                                                                data?.type === TxnType.OCEAN_FREIGHT_CHARGE ? 'Ocean Freight Charge' :
                                                                                                                                data?.type === TxnType.VENDOR_PREPAID ? 'Vendor Prepaid' :

                                                                                                                                data?.type === TxnType.LIBERATION_TARIFF_FEE ? 'Liberation Tariff Fee' :
                                                                                                                                data?.type === TxnType.LIFTGATE_SERVICE_FEE ? 'Liftgate Service Fee' :
                                                                                                                                data?.type === TxnType.GROUND_TRANSPORTATION ? 'Ground Transportation' :
                                                                                                                                data?.type === TxnType.LCL_OCEAN_FREIGHT ? 'LCL - Ocean Freight' :
                                                                                                                                data?.type === TxnType.FCL_OCEAN_FREIGHT ? 'FCL - Ocean Freight' :
                                                                                                                                data?.type === TxnType.DUTY_AND_VAT ? 'Duty & VAT' :
                                                                                                                                data?.type === TxnType.DAILY_STORAGE ? 'Daily Storage' :
                                                                                                                                data?.type === TxnType.WEEKLY_STORAGE ? 'Weekly Storage' :
                                                                                                                                data?.type === TxnType.MONTHLY_STORAGE ? 'Monthly Storage' :
                                                                                                                                data?.type === TxnType.ANNUAL_STORAGE ? 'Annual Storage' :
                                                                                                                                data?.type === TxnType.PROJECT_REWORK ? 'Project Rework' :
                                                                                                                                data?.type === TxnType.ASSEMBLY ? 'Assembly' :
                                                                                                                                data?.type === TxnType.EXPORT ? 'Export' :
                                                                                                                                data?.type === TxnType.IMPORT ? 'Import' :
                                                                                                                                data?.type === TxnType.CTF_TMF ? 'CTF/TMF' :





                                                                                                                                                                                  data?.type?.replace(/(\w)(\w*)/g, function(g0, g1, g2) {
                                                                                                                                                                                    return g1.toUpperCase() + g2.toLowerCase();
                                                                                                                                                                                  });
};


export const CORPORATE = 'CORPORATE';
export const EFS = 'EFS';
export const OFFICE_CHARGE = 'OFFICE_CHARGE';
export const FUEL = 'FUEL';
export const PROCESSING_REVERSAL = 'LPF_CARRIER_CREDIT';
export const QUICKPAY = 'QUICKPAY';
export const PREPAY_FEE = 'PREPAY_FEE';


export const transactionType = userType === 'ADMIN' ?
  sortByNameWithAlphabetical([
    { name: 'Exam Fee', id: TxnType.EXAM_FEE },
    { name: 'Lumper', id: 'LUMPER' },
    { name: 'Detention', id: 'DETENTION' },
    { name: 'Layover', id: 'LAYOVER' },
    { name: 'Warehousing', id: TxnType.WAREHOUSING },
    { name: 'Driver Assist', id: 'DRIVERASSIST' },
    { name: 'Palletizing', id: 'PALLETIZING' },
    { name: 'Drayage', id: 'DRAYAGE' },
    { name: 'Chassis Fee', id: 'CHASSIS_FEE' },
    { name: 'Drop Fee', id: 'DROP_FEE' },
    { name: 'FSC', id: 'FSC' },
    { name: 'Pre-Pull', id: 'PRE_PULL' },
    { name: 'Per Diem', id: 'PRE_DIEM' },
    { name: 'Pier Pass (CTF/TMF) fee', id: 'PIER_PASS' },
    { name: 'Container Storage', id: 'CONTAINER_STORAGE' },
    { name: 'Demurrage', id: 'DEMURRAGE' },
    { name: 'Chassis Split', id: 'CHASSIS_SPLIT' },
    ...sameTransactions,
    { name: 'Quickpay Reversal', id: 'QUICKPAY_REVERSAL', warn: true },
    { name: 'Quickpay', id: 'QUICKPAY', warn: true },
    { name: 'EFS', id: 'EFS', warn: true },
    { name: 'Fuel', id: 'FUEL', warn: true },
    { name: 'Office Transaction', id: 'OFFICE_CHARGE', warn: true },
    { name: 'Corporate Transaction', id: 'CORPORATE', warn: true },
    { name: 'Prepaid Expense', id: TxnType.PREPAY_FEE, warn: true },
    // { name: 'Prepaid Expense ', id: TxnType.PREPAID_EXPENSE, warn: true },
    { name: 'Vendor Expense ', id: TxnType.VENDOR_EXPENSE, warn: true },
    { name: 'Customer Expense ', id: TxnType.CUSTOMER_EXPENSE, warn: true },
    { name: 'Vendor Charge ', id: TxnType.VENDOR_CHARGE, warn: true },
  ])
  :
  sortByNameWithAlphabetical([
    { name: 'Exam Fee', id: TxnType.EXAM_FEE },
    { name: 'Detention', id: 'DETENTION' },
    { name: 'Layover', id: 'LAYOVER' },
    { name: 'Warehousing', id: TxnType.WAREHOUSING },
    { name: 'Driver Assist', id: 'DRIVERASSIST' },
    { name: 'Palletizing', id: 'PALLETIZING' },
    { name: 'Drayage', id: 'DRAYAGE' },
    { name: 'Chassis Fee', id: 'CHASSIS_FEE' },
    { name: 'Drop Fee', id: 'DROP_FEE' },
    { name: 'FSC', id: 'FSC' },
    { name: 'Pre-Pull', id: 'PRE_PULL' },
    { name: 'Per Diem', id: 'PRE_DIEM' },
    { name: 'Pier Pass (CTF/TMF) fee', id: 'PIER_PASS' },
    { name: 'Container Storage', id: 'CONTAINER_STORAGE' },
    { name: 'Demurrage', id: 'DEMURRAGE' },
    { name: 'Chassis Split', id: 'CHASSIS_SPLIT' },
    { name: 'Office Transaction', id: 'OFFICE_CHARGE' },
    ...sameTransactions,
  ]);


export const otherTransactionHead = [
  { name: '', title: 'Created Date', icon: 'date', custom: false, width: '100px' },
  { name: '', title: 'Creator', custom: false },
  {
    name: 'otherType', title: 'Type',
    filterList: [
      { name: 'All', id: '' },
      { name: 'Corporate Transaction', id: 'CORPORATE' },
      { name: 'Office Transaction', id: 'OFFICE_CHARGE' },
    ],
  },
  { name: '', title: 'Rate', custom: false },
  { name: 'qty', title: 'Qty', custom: false, width: '100px' },
  { name: '', title: 'Total', custom: false },
  { name: '', title: 'Description', custom: false },
  {
    name: 'otherVoid', title: 'Action', custom: false,
    // filterList: transactionStatuses,
    width: '120px',
  },
];

export const otherTransactionBody = (editDesc) => [
  { rowText: (item) => <DateRow date={item?.createdDate} /> },
  { rowText: (item) => <TextRow name={item?.username} textWidth={10} /> },
  { rowText: (item) => <div>{handleGetTypes(item)}</div> },
  { rowText: (item) => <p className={redColor}><PriceRow info={item?.amount} minuse={true} /></p> },
  { rowText: (item) => <TextRow name={item?.qty ? item?.qty : 1} textWidth={10} /> },
  {
    rowText: (item) => <p className={redColor}><PriceRow info={item?.amount} minuse={true} /></p>,
    // rowText: (item) =>  renderPriceRow(item?.totalAmount, item)
  },
  {
    rowText: (item) => <div className="align-center">
      <TextRow name={item?.description} textWidth={13} />
      <button className="reset-btn" onClick={() => editDesc(item)}>
        <img src={Images.edit} alt="edit" />
      </button>
    </div>,
  },
  userType === 'ADMIN' && RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.TRANSACTION_VOID_BUTTON?.code]) ?
    { button: (item, info, load) => renderButton(item, info, load), notClickable: true }
    :
    '',
];
